import api from '../api/axiosConfig';

// Checks if a Cognito user exists for the given email. Returns true/false.
export async function checkCognitoUserExists(email) {
  try {
    const res = await api.post('/auth/check-user-exists', { email });
    // The backend returns { exists: true } or { exists: false }
    return !!(res.data && res.data.exists === true);
  } catch (err) {
    return false;
  }
}
